<template>
  <div>
    <b-card class="question-item">
      <b-row>
        <b-col>
          <b-img
            :src="question.student.user.avatar"
            width="40%"
            class="float-right"
            rounded="circle"
            alt="Circle image"
          ></b-img>
        </b-col>
        <b-col cols="8">
          <h3 class="text-dark">
            <strong>{{question.title}}</strong>
          </h3>
          <h6 class="text-dark">{{question.question}}</h6>

          <span class="mt-3">
            <span class="text-info">
              <small>Por {{question.student.user.name}}</small>
            </span>
            <span class="text-muted">
              <small>{{question.created_at | time}}</small>
            </span>
          </span>
        </b-col>
        <b-col>
          <h3 class="text-dark">
            <span>Ver respuestas ({{question.answers.length}})</span>
            <i style="font-size:20px" class="fas fa-comments"></i>
          </h3>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
  import moment from "moment";

  export default {
    props: {
      question: Object
    },
    filters: {
      time(val) {
        moment.locale("es");
        return moment(val, "YYYY-MM-DD HH:mm:ss").fromNow();
      }
    }
  };
</script>

<style scoped>
  .question-item {
    transition: all 300ms ease;
    cursor: pointer;
  }

  .question-item:hover {
    transition: all 300ms ease;
    background: #f9f9fa !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/#public/curse/components/content/QuestionListItem.vue